export default "__VITE_ASSET__DEDm$bB3__"